import { captureException, captureMessage } from "../config/sentry";

/**
 * Global error handler for unhandled errors and promise rejections
 */
export class GlobalErrorHandler {
  static initialized = false;

  /**
   * Initialize global error handlers
   */
  static init() {
    if (this.initialized) {
      return;
    }

    // Handle unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => {
      console.error('Unhandled promise rejection:', event.reason);

      captureException(event.reason, {
        type: 'unhandledPromiseRejection',
        timestamp: new Date().toISOString(),
        browser: {
          userAgent: navigator.userAgent,
          url: window.location.href,
        },
      });

      // Prevent the default handler (which logs to console)
      event.preventDefault();
    });

    // Handle uncaught errors
    window.addEventListener('error', (event) => {
      console.error('Uncaught error:', event.error);

      captureException(event.error, {
        type: 'uncaughtError',
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        timestamp: new Date().toISOString(),
        browser: {
          userAgent: navigator.userAgent,
          url: window.location.href,
        },
      });
    });

    // Handle resource loading errors
    window.addEventListener('error', (event) => {
      if (event.target !== window) {
        console.error('Resource loading error:', event.target.src || event.target.href);

        captureMessage(
          `Resource loading error: ${event.target.src || event.target.href}`,
          'error',
          {
            type: 'resourceLoadingError',
            resource: {
              src: event.target.src,
              href: event.target.href,
              tagName: event.target.tagName,
            },
            timestamp: new Date().toISOString(),
            browser: {
              userAgent: navigator.userAgent,
              url: window.location.href,
            },
          }
        );
      }
    }, true);

    this.initialized = true;
    console.log('Global error handlers initialized');
  }

}

export default GlobalErrorHandler;
